import { render, staticRenderFns } from "./AvatarWrapperSmall.vue?vue&type=template&id=46c66992&scoped=true&"
import script from "./AvatarWrapperSmall.vue?vue&type=script&lang=js&"
export * from "./AvatarWrapperSmall.vue?vue&type=script&lang=js&"
import style0 from "./AvatarWrapperSmall.vue?vue&type=style&index=0&id=46c66992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c66992",
  null
  
)

export default component.exports